import { Pie } from 'vue-chartjs'

export default {
    extends: Pie,
    mounted () {
        // Overwriting base render method with actual data.
        this.renderChart({
        labels: ['Выздоровевших %', 'Летальных исходов %', 'Случаи короновируса %',],
        datasets: [
                {
                    label: 'GitHub Commits',
                    backgroundColor: [
                        '#41B883',
                        '#E46651',
                        '#00D8FF',
                    ],

                    data: [124349/(532279/100), 24090/(532279/100), 532279/(532279/100)]
                }
            ]
        }, {responsive: true, maintainAspectRatio: false} )
    }
}